export const startMapLoading = (payload) => {
  return {
    type: 'START_HUNT_PLANNER_MAP_LOADER',
  }
}

export const stopMapLoading = () => {
  return {
    type: 'STOP_HUNT_PLANNER_MAP_LOADER',
  }
}

